import { render, staticRenderFns } from "./ConfigEmailHabeasData.vue?vue&type=template&id=22aa95aa&scoped=true"
import script from "./ConfigEmailHabeasData.vue?vue&type=script&lang=js"
export * from "./ConfigEmailHabeasData.vue?vue&type=script&lang=js"
import style0 from "./ConfigEmailHabeasData.vue?vue&type=style&index=0&id=22aa95aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa95aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22aa95aa')) {
      api.createRecord('22aa95aa', component.options)
    } else {
      api.reload('22aa95aa', component.options)
    }
    module.hot.accept("./ConfigEmailHabeasData.vue?vue&type=template&id=22aa95aa&scoped=true", function () {
      api.rerender('22aa95aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/ConfigEmailHabeasData.vue"
export default component.exports